var exports = {
  "kL": "WebhookListItem.module__container___dUc5OV",
  "aY": "WebhookListItem.module__headerButton___dUc5OV",
  "kb": "WebhookListItem.module__left___dUc5OV",
  "Jb": "WebhookListItem.module__avatarLarge___dUc5OV",
  "fI": "WebhookListItem.module__textBlock___dUc5OV",
  "$": "WebhookListItem.module__titleRow___dUc5OV",
  "UU": "WebhookListItem.module__name___dUc5OV",
  "ML": "WebhookListItem.module__channelTag___dUc5OV",
  "KW": "WebhookListItem.module__metaRow___dUc5OV",
  "K9": "WebhookListItem.module__channelTagMobile___dUc5OV",
  "ai": "WebhookListItem.module__chevron___dUc5OV",
  "hg": "WebhookListItem.module__chevronExpanded___dUc5OV",
  "zH": "WebhookListItem.module__details___dUc5OV",
  "J1": "WebhookListItem.module__detailsRow___dUc5OV",
  "Mc": "WebhookListItem.module__avatarColumn___dUc5OV",
  "Pf": "WebhookListItem.module__label___dUc5OV",
  "_Q": "WebhookListItem.module__avatarPreview___dUc5OV",
  "OA": "WebhookListItem.module__fields___dUc5OV",
  "EN": "WebhookListItem.module__fieldsRow___dUc5OV",
  "ch": "WebhookListItem.module__fieldGrow___dUc5OV",
  "o1": "WebhookListItem.module__actions___dUc5OV",
  "Dy": "WebhookListItem.module__avatarActions___dUc5OV",
  "B": "WebhookListItem.module__urlWrapper___dUc5OV",
  "UQ": "WebhookListItem.module__monoInput___dUc5OV",
  "Bx": "WebhookListItem.module__iconSmall___dUc5OV",
  "xv": "WebhookListItem.module__truncate___dUc5OV",
};

module.exports = exports;
